import $ from "jquery";
import ko from "knockout";
import debugHelper from "flow/utils/debugHelper";
import register from "flow/knockout/register";
import Component from "flow/Component";

register.registerKnockoutBinding("flowComponent", {
    init: function (element, valueAccessor) {
        const $containerElement = $("<div></div>");
        $containerElement.addClass("stretchAbsolute");
        const containerElement = $containerElement[0];
        ko.virtualElements.prepend(element, containerElement);

        const componentObs = valueAccessor();

        if (ko.isObservable(componentObs) === false) {
            // Simple case, won't be able to change since it is not an observable
            const component = componentObs; // Use other variable for clarity
            component.load().done(() => {
                $containerElement.html(component.viewHtml());

                const attributes = debugHelper.generateAttrObjectFromManifest(component.manifest);
                debugHelper.setAttributes(element, attributes);

                if (component.useValidationV3()) {
                    ko.applyBindingsWithValidation(
                        component.viewModel(),
                        containerElement,
                        component.validationOptionsV3()
                    );
                } else {
                    ko.applyBindings(component.viewModel(), containerElement);
                }

                component.onViewAttached(containerElement);
            });
            return { controlsDescendantBindings: true };
        }

        let currentComponent = componentObs();

        const handleComponentChange = function (newComponent: Component) {
            currentComponent = newComponent;

            if (newComponent === null || newComponent === undefined) {
                ko.cleanNode(containerElement);
                $containerElement.html("");
                return;
            }

            newComponent.load().done(() => {
                // Abort if component has changed while we were loading
                if (newComponent === currentComponent) {
                    ko.cleanNode(containerElement);
                    $containerElement.html(newComponent.viewHtml());

                    const attributes = debugHelper.generateAttrObjectFromManifest(newComponent.manifest);
                    debugHelper.setAttributes(element, attributes);

                    if (newComponent.useValidationV3()) {
                        ko.applyBindingsWithValidation(
                            newComponent.viewModel(),
                            containerElement,
                            newComponent.validationOptionsV3()
                        );
                    } else {
                        ko.applyBindings(newComponent.viewModel(), containerElement);
                    }

                    newComponent.onViewAttached(containerElement);
                }
            });
        };

        const subscription = componentObs.subscribe(handleComponentChange);

        if (componentObs()) {
            handleComponentChange(componentObs());
        }

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            subscription.dispose();
        });

        return { controlsDescendantBindings: true };
    }
});
